(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["az-product-film"] && !Shopify.designMode) return;
  try {
    (()=>{
    function init(){
      document.querySelectorAll('article').forEach(article=>{
        const hero=article.querySelector('[data-az-banner]');
        const dialog=article.querySelector('.az-film-dialog');
        if(!hero||!dialog||hero.dataset.azReady)return;
        hero.dataset.azReady='true';hero.muted=true;hero.defaultMuted=true;
        const player=dialog.querySelector('video');let returnTo=null,resume=false,visible=true,overflow='';
        const play=()=>hero.play().catch(()=>{});
        hero.addEventListener('error',()=>{if(hero.dataset.fallback&&hero.src!==hero.dataset.fallback){hero.src=hero.dataset.fallback;play()}});
        const watch=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(!visible)hero.pause();else if(!dialog.open&&!document.hidden)play()},{threshold:.1});watch.observe(hero);
        document.addEventListener('visibilitychange',()=>{if(document.hidden)hero.pause();else if(visible&&!dialog.open)play()});
        article.querySelectorAll('[data-product-slider]').forEach(gallery=>{
          const items=[...gallery.querySelectorAll('[data-slider-item]')];
          gallery.querySelectorAll('[data-az-film-source]').forEach(button=>{
            const index=items.indexOf(button.closest('[data-slider-item]'));
            const thumb=gallery.querySelector('[data-slider-dot="'+index+'"]');
            if(thumb){thumb.dataset.azFilmSource=button.dataset.azFilmSource;thumb.dataset.azFilmPoster=button.dataset.azFilmPoster;}
          });
        });
        article.addEventListener('click',event=>{
          const button=event.target.closest('[data-az-film-source]');if(!button||dialog.open)return;
          event.preventDefault();event.stopImmediatePropagation();returnTo=button;resume=!hero.paused;hero.pause();
          player.src=button.dataset.azFilmSource;player.poster=button.dataset.azFilmPoster||'';
          overflow=document.documentElement.style.overflow;dialog.showModal();document.documentElement.style.overflow='hidden';player.play().catch(()=>{});
        },true);
        dialog.querySelector('[data-az-close]').addEventListener('click',()=>dialog.close());
        let backdrop=false;dialog.addEventListener('pointerdown',event=>{backdrop=event.target===dialog});
        dialog.addEventListener('click',event=>{if(event.target===dialog&&backdrop)dialog.close();backdrop=false});
        dialog.addEventListener('close',()=>{player.pause();document.documentElement.style.overflow=overflow;if(returnTo?.isConnected)returnTo.focus({preventScroll:true});if(resume&&visible&&!document.hidden)play()});
        play();
      });
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
    document.addEventListener('shopify:section:load',init);
  })();
  } catch(e) { console.error(e); }
})();

})();
